import React from "react";
import FireWorks from "./FireWorks";
function CampusLeaderBoard() {
  return <FireWorks />;
}

export default CampusLeaderBoard;
